class AliaButton extends HTMLElement {
  constructor() {
    super();

    this.btn = this.querySelector('[data-alia-form-id]');
    this.aliaFormId = Number(this.btn.getAttribute('data-alia-form-id'));

    this.addEventListener('click', (event) => {
      if (!this.aliaSdkLoaded()) return;

      event.preventDefault();
      window.alia = window.alia || [];

      window.alia.push({
        type: "open",
        campaignID: this.aliaFormId,
        ignoreTargeting: true
      });
    });
  }

  aliaSdkLoaded() {
    return typeof window.alia === 'object' && window.alia !== null && !Array.isArray(window.alia);
  }
}

customElements.define('alia-button', AliaButton);
